export default __webpack_public_path__ + "static/laser_on_projector-9410718a9c20a193c083303e68bf1b6f.jpg";